import './styles.css';
import moduleConfig from './module-config';
import netsLoader from './nets-loader';

export default angular
  .module('app.loader', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsLoader', netsLoader);
